export const mergeEacContactUpdates = (selectedCards, updatedCards) =>
  selectedCards.map((selectedCard) => {
    const updatedCard = updatedCards.find(
      (card) => card.cardNumber === selectedCard.cardNumber,
    );
    return updatedCard
      ? { ...selectedCard, gsm: updatedCard.gsm, email: updatedCard.email }
      : selectedCard;
  });
